import { Reducer } from "../../../node_modules/react-redux-form";
import { GiveFeedbackModel } from "../models/GiveFeedbackModels";

export enum ActionType {
    GiveFeedback = "FEEDBACK/GIVE_FEEDBACK",
    GiveFeedbackStarted = "FEEDBACK/GIVE_FEEDBACK_STARTED",
    GiveFeedbackFinished = "FEEDBACK/GIVE_FEEDBACK_FINISHED",
    GiveFeedbackSuccess = "FEEDBACK/GIVE_FEEDBACK_SUCCESS",
    GiveFeedbackSubmit = "FEEDBACK/GIVE_FEEDBACK_SUBMIT",
    GiveFeedbackCancel = "FEEDBACK/GIVE_FEEDBACK_CANCEL"
}

interface GiveFeedbackAction {
    type: ActionType.GiveFeedback;
}

interface GiveFeedbackStartedAction {
    type: ActionType.GiveFeedbackStarted;
}

interface GiveFeedbackFinishedAction {
    type: ActionType.GiveFeedbackFinished;
}

interface GiveFeedbackSuccessAction {
    type: ActionType.GiveFeedbackSuccess;
}

interface GiveFeedbackSubmitAction {
    type: ActionType.GiveFeedbackSubmit;
    data: GiveFeedbackModel;
}

interface GiveFeedbackCancelAction {
    type: ActionType.GiveFeedbackCancel
}

export const actionCreators = {
    giveFeedback: () => <GiveFeedbackAction>{ type: ActionType.GiveFeedback },
    giveFeedbackStarted: () => <GiveFeedbackStartedAction>{ type: ActionType.GiveFeedbackStarted },
    giveFeedbackFinished: () => <GiveFeedbackFinishedAction>{ type: ActionType.GiveFeedbackFinished },
    giveFeedbackSubmit: (data: GiveFeedbackModel) => <GiveFeedbackSubmitAction>{ type: ActionType.GiveFeedbackSubmit, data },
    giveFeedbackCancel: () => <GiveFeedbackCancelAction>{ type: ActionType.GiveFeedbackCancel }
}

export interface GiveFeedbackState {
    isDialogOpen: boolean;
}

type ValidAction = GiveFeedbackStartedAction | GiveFeedbackFinishedAction;

const initialState: GiveFeedbackState = {
    isDialogOpen: false
}

export const reducer: Reducer<GiveFeedbackState> = (state: GiveFeedbackState, action: ValidAction) => {

    switch (action.type) {
        case ActionType.GiveFeedbackStarted:
            return {
                isDialogOpen: true
            }
        case ActionType.GiveFeedbackFinished:
            return {
                isDialogOpen: false
            }
        default:
            const exCheck: never = action;
    }

    return state || initialState;
}


// WEBPACK FOOTER //
// ./src/feedback/store/giveFeedbackStore.ts